export default __webpack_public_path__ + "static/media/icon_close_grey.51b60c6b.svg";